import axios, { type AxiosInstance } from 'axios';
import { handleSessionExpired, isAuthErrorStatus } from '../utils/sessionExpiry';

const attached = new WeakSet<AxiosInstance>();

export function attachSessionExpiryInterceptor(instance: AxiosInstance): void {
  if (attached.has(instance)) {
    return;
  }
  attached.add(instance);

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isAxiosError(error) && isAuthErrorStatus(error.response?.status)) {
        const payload = error.response?.data as { message?: string; error?: string } | string | undefined;
        const serverMessage =
          (typeof payload === 'string' && payload.trim()) ||
          (typeof payload === 'object' && payload?.message) ||
          (typeof payload === 'object' && payload?.error) ||
          undefined;
        handleSessionExpired(
          typeof serverMessage === 'string' ? serverMessage : undefined,
        );
      }
      return Promise.reject(error);
    },
  );
}
